<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Delete rate</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <p>
                Deleted rates cannot be returned, are you sure you want to
                delete this?
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="close">
          Cancel
        </v-btn>
        <v-btn
          color="error"
          :loading="loading"
          :disabled="loading"
          @click="deleteRate"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UploadRateModal",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    rate: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    deleteRate() {
      this.loading = true;
      this.$store
        .dispatch("RecordStore/delete", {
          sendingCountryIso3: this.rate.sendingCountryIso3,
          sendingCurrency: this.rate.sendingCurrency,
          receiveCountryIso3: this.rate.receiveCountryIso3,
          receiveCurrency: this.rate.receiveCurrency,
          serviceCode: this.rate.serviceCode,
          segment: this.rate.segment || "STANDARD"
        })
        .then(() => {
          this.$emit("delete", this.rate);
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
